import React, { useEffect, useState } from "react";
import { ReactComponent as IconCloseCircle } from "../../../build/images/platformnps/closecircle.svg";
import { ReactComponent as IconDeslikeSelected } from "../../../build/images/platformnps/deslikeselected.svg";
import { ReactComponent as IconDeslikeUnselected } from "../../../build/images/platformnps/deslikeunselected.svg";
import { ReactComponent as IconLikeSelected } from "../../../build/images/platformnps/likeselected.svg";
import { ReactComponent as IconLikeUnselected } from "../../../build/images/platformnps/likeunselected.svg";
import { ReactComponent as IconLikeDisabled } from "../../../build/images/platformnps/likedisabled.svg";
import { ReactComponent as IconDeslikeDisabled } from "../../../build/images/platformnps/deslikedisable.svg";
import { ReactComponent as IconIReviewed } from "../../../build/images/nps-dashboard-icons/iconi.svg";
import Button from "../Button";
import MicroModal from "micromodal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { connection_platform } from "../../../services/api";
import { editDetailsNps } from "../../../actions";

// let url_connection = `${connection_platform.type_connect}:${localStorage.getItem("pathname")}:${localStorage.getItem("port")}`
// let url_connection = `https://cloud.ingweb.com.br:8080`

let port = localStorage.getItem("port");
let url_connection = `${connection_platform.type_connect}://${connection_platform.ip_intern}:${port}`;

const EditEvaluationModal = ({ modalTitle }) => {
  const [evaluations, setEvaluations] = useState([]);
  const [textObservation, setTextObservation] = useState("");
  const [isReviewed, setIsReviewed] = useState(false);
  const clientAnswerReducer = useSelector((state) => state.atendimento);
  const npsDetailsTotal = useSelector((state) => state.npsdetails);
  const npsDetailsReducer = npsDetailsTotal.filter(
    (nps) => nps.numero_cliente === clientAnswerReducer.telefone
  );
  const userReducer = useSelector((state) => state.informationusers);
  const dispatch = useDispatch();
  const data = {
    profile:
      npsDetailsReducer.length !== 0
        ? returnedNameNps(npsDetailsReducer[0].nota_nps)
        : "",
    note: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].nota_nps : "",
    attendance:
      npsDetailsReducer.length !== 0
        ? npsDetailsReducer[0].data_atendimento
        : "",
    unit: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].unidade : "",
    datetime:
      npsDetailsReducer.length !== 0
        ? npsDetailsReducer[0].data_atendimento
        : "",
    phone:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].numero_cliente : "",
    serviceattid:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].id_atendimento : "",
    cdrid: npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].id_cdr : "",
    status:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].id_deal_status : "",
    userid: userReducer.id,
    clientname:
      npsDetailsReducer.length !== 0 ? npsDetailsReducer[0].nome_cliente : "",
  };

  function returnedNameNps(note) {
    if (parseInt(note) <= 6) {
      return "Detrator";
    }

    if (parseInt(note) === 7 || parseInt(note) === 8) {
      return "Neutro";
    }

    if (parseInt(note) === 9 || parseInt(note) === 10) {
      return "Promotor";
    }
  }

  const getEvaluations = async () => {
    const response = await axios.get(
      `${url_connection}/conn/get-evaluation?idcdr=${data.cdrid}`
    );
    const evaluationReturns = response.data;
    let observationReturned = "";
    if (evaluationReturns.length !== 0) {
      setIsReviewed(evaluationReturns[0].reavaliacao);
    }
    evaluationReturns.map((evaluation) => {
      evaluation.marked = true;
      evaluation.jsonPossibilidades = JSON.parse(evaluation.possibilidades);
      evaluation.jsonRespostas = JSON.parse(evaluation.respostas);

      evaluation.jsonReasons = JSON.parse(evaluation.razoes_possibilidades);
      evaluation.jsonSubQ = [];

      if (evaluation.jsonRespostas.length !== 0) {
        evaluation.jsonSubQ = JSON.parse(
          evaluation.jsonRespostas[evaluation.jsonRespostas.length - 1]
            .resposta_subq
        );
        evaluation.id_valor =
          evaluation.jsonRespostas[
            evaluation.jsonRespostas.length - 1
          ].id_resposta;
        evaluation.valor =
          evaluation.jsonRespostas[evaluation.jsonRespostas.length - 1].valor;
        evaluation.respostaSelected =
          evaluation.jsonRespostas[
            evaluation.jsonRespostas.length - 1
          ].resposta;
        evaluation.respostaSelectedOld =
          evaluation.jsonRespostas[
            evaluation.jsonRespostas.length - 1
          ].resposta;
        evaluation.scopenew =
          evaluation.jsonRespostas[
            evaluation.jsonRespostas.length - 1
          ].id_resposta;
        evaluation.scopeold =
          evaluation.jsonRespostas[
            evaluation.jsonRespostas.length - 1
          ].id_resposta;
        evaluation.answerold =
          evaluation.jsonRespostas[evaluation.jsonRespostas.length - 1].valor;
        if (evaluation.tipo_questao === 1)
          evaluation.profileNps = returnedNameNps(
            evaluation.jsonRespostas[evaluation.jsonRespostas.length - 1]
              .resposta
          );
      }
      evaluation.textObservation = "";
      evaluation.jsonMarked = [];

      if (evaluation.observacao !== null) {
        observationReturned = evaluation.observacao;
      }
    });
    setTextObservation(observationReturned);
    setEvaluations(response.data);
  };

  const insertEvaluationNote = async () => {
    let changedProfile = false;
    let changedPerfil = false;
    for (const evaluation of evaluations) {
      // evaluations.map(async evaluation => {
      await axios.get(
        `${url_connection}/conn/insert-evaluation-review-v2?id_question=${evaluation.id_pergunta}&id_att_description=${data.serviceattid}&id_evaluation=${evaluation.id_avaliacao}&answer=${evaluation.valor}&idresposta=${evaluation.id_valor}&userinsert=${userReducer.id}&observation=${textObservation}&scopenew=${evaluation.scopenew}&scopeold=${evaluation.scopeold}&answerold=${evaluation.answerold}`
      );
      if (evaluation.tipo_questao === 1) {
        dispatch(
          editDetailsNps(data.phone, parseInt(evaluation.respostaSelected))
        );
      }
      if (evaluation.respostaSelected !== evaluation.respostaSelectedOld) {
        changedProfile = true;
      }
      if (evaluation.tipo_questao === 1) {
        if (
          returnedNameNps(evaluation.respostaSelected) !== evaluation.profileNps
        ) {
          changedPerfil = true;
        }
      }
    }
    // )
    if (data.status === null && npsDetailsReducer.length !== 0) {
      await axios.get(
        `${url_connection}/conn/insert-deal-attendance?idatendimento=${data.serviceattid}&user_response=${userReducer.id}&id_deal_status=2&cdrid=${data.cdrid}&changed_profile=${changedProfile}&changed_perfil=${changedPerfil}`
      );
    } else if (data.status !== null && npsDetailsReducer.length !== 0) {
      await axios.get(
        `${url_connection}/conn/update-deal-attendance?idatendimento=${data.serviceattid}&user_response=${userReducer.id}&id_deal_status=2&cdrid=${data.cdrid}&changed_profile=${changedProfile}&changed_perfil=${changedPerfil}`
      );
    }
    MicroModal.close("modal-component-edit-evaluation-modal");
    getEvaluations();
  };

  const handleMarkedNegativedService = (
    idPossibilidade,
    idEvaluation,
    jsonMarked
  ) => {
    let arrayPossibilidadesNegatived = jsonMarked;
    if (arrayPossibilidadesNegatived.includes(idPossibilidade)) {
      arrayPossibilidadesNegatived = arrayPossibilidadesNegatived.filter(
        (n) => n !== idPossibilidade
      );
    } else {
      arrayPossibilidadesNegatived.push(idPossibilidade);
    }
    const arrayEvaluations = evaluations.map((evaluation) =>
      evaluation.id_avaliacao === parseInt(idEvaluation)
        ? { ...evaluation, jsonMarked: arrayPossibilidadesNegatived }
        : evaluation
    );
    setEvaluations(arrayEvaluations);
  };

  const handleEvaluationMark = (idQuestion, marked, jsonRespostas) => {
    let valor = "";
    let id_valor = "";
    let respostaSelected;
    jsonRespostas.map((json) => {
      if (marked === true) {
        if (json.resposta === "Bom") {
          id_valor = json.id_resposta;
          valor = json.valor;
          respostaSelected = json.resposta;
        }
      } else {
        if (json.resposta === "Ruim") {
          id_valor = json.id_resposta;
          valor = json.valor;
          respostaSelected = json.resposta;
        }
      }
    });
    const arrayEvaluations = evaluations.map((evaluation) =>
      evaluation.id_pergunta === parseInt(idQuestion)
        ? {
            ...evaluation,
            marked: marked,
            valor: valor,
            id_valor: id_valor,
            respostaSelected: respostaSelected,
            respostaSelecionadaAtual: {
              resposta: respostaSelected,
              id_resposta: id_valor,
              valor,
            },
            scopenew: id_valor,
          }
        : evaluation
    );
    setEvaluations(arrayEvaluations);
  };

  useEffect(() => {
    getEvaluations();
  }, [npsDetailsTotal]);

  const closeModal = () => {
    MicroModal.close("modal-component-edit-evaluation-modal");
  };

  const handleTextAreaEvaluation = (text, idEvaluation) => {
    const arrayEvaluations = evaluations.map((evaluation) =>
      evaluation.id_avaliacao === parseInt(idEvaluation)
        ? { ...evaluation, textObservation: text }
        : evaluation
    );
    setEvaluations(arrayEvaluations);
  };

  const handleNpsNote = (resposta, idValor, valor, idPergunta) => {
    const arrayEvaluations = evaluations.map((evaluation) =>
      evaluation.id_pergunta === parseInt(idPergunta)
        ? {
            ...evaluation,
            respostaSelected: resposta,
            id_valor: idValor,
            valor: valor,
            respostaSelecionadaAtual: {
              resposta,
              id_resposta: idValor,
              valor,
            },
            scopenew: idValor,
          }
        : evaluation
    );
    setEvaluations(arrayEvaluations);
  };

  return (
    <div
      className="modal micromodal-slide"
      id="modal-component-edit-evaluation-modal"
      aria-hidden="true"
    >
      <div className={`modal__overlay`} aria-modal="true" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          style={{ padding: "24px", borderRadius: "8px" }}
        >
          <div className="modal-component__general">
            <div className="modal-component__general__header">
              <span>{modalTitle}</span>
              <div className="modal_close" onClick={() => closeModal()}>
                <IconCloseCircle />
              </div>
            </div>
            {isReviewed && (
              <div className="modal-component__general__body-selected1__reviewed">
                <div>
                  <IconIReviewed />
                </div>
                <div className="modal-component__general__body-selected1__reviewed-title">
                  <p>Pesquisa reavaliada!</p>
                  <span>
                    Sua pesquisa foi revisada com sucesso e está pronta.
                  </span>
                </div>
              </div>
            )}
            <div className="modal-component__general__body">
              {evaluations.filter((todo) => todo.tipo_questao === 1).length !==
                0 &&
                evaluations
                  .filter((todo) => todo.tipo_questao === 1)
                  .map((evaluation) => (
                    <>
                      <div className="modal-component__general__body-indication">
                        <p>{evaluation.pergunta}</p>
                      </div>
                      <div className="modal-component__general__body-note">
                        {evaluation.jsonPossibilidades.map((todo) => (
                          <div
                            onClick={
                              isReviewed
                                ? () => {}
                                : () =>
                                    handleNpsNote(
                                      todo.resposta,
                                      todo.id_resposta,
                                      todo.valor,
                                      evaluation.id_pergunta
                                    )
                            }
                            className={
                              todo.resposta === evaluation.respostaSelected
                                ? `modal-component__general__body-note__number-active nps-${todo.resposta}`
                                : "modal-component__general__body-note__number"
                            }
                            key={todo.resposta}
                          >
                            <span>{todo.resposta}</span>
                          </div>
                        ))}
                      </div>
                      <div className="modal-component__general__body-indication">
                        <p>O que você achou da sua experiência?</p>
                      </div>
                    </>
                  ))}
            </div>
            {/* <div className="modal-component__general__body-selected1">
                    <span>O atendimento foi*</span>
                    <div className="modal-component__general__body-selected1__box" onClick={() => setEvalutaionOne(true)}>
                        {evaluationOne ? <IconLikeSelected />:<IconLikeUnselected />}
                        <span>Bom</span>
                    </div>
                    <div className="modal-component__general__body-selected1__box" onClick={() => setEvalutaionOne(false)}>
                        {evaluationOne ? <IconDeslikeUnselected />:<IconDeslikeSelected />}
                        <span>Ruim</span>
                    </div>
                </div> */}
            <div className="modal-component__general__body-selecteds">
              {evaluations
                .filter(
                  (todo) => todo.tipo_questao === 2 && todo.id_father === null
                )
                .map((evaluation) => (
                  <div className="modal-component__general__body-selected1">
                    <div className="modal-component__general__body-selected1__conjunct">
                      <span>{evaluation.pergunta}</span>
                      <div
                        className="modal-component__general__body-selected1__box"
                        onClick={
                          isReviewed
                            ? () => {}
                            : () =>
                                handleEvaluationMark(
                                  evaluation.id_pergunta,
                                  true,
                                  evaluation.jsonPossibilidades
                                )
                        }
                      >
                        {evaluation.valor === 5 ? (
                          <IconLikeSelected />
                        ) : isReviewed ? (
                          <IconLikeDisabled />
                        ) : (
                          <IconLikeUnselected />
                        )}
                        <span>Bom</span>
                      </div>
                      <div
                        className="modal-component__general__body-selected1__box"
                        onClick={
                          isReviewed
                            ? () => {}
                            : () =>
                                handleEvaluationMark(
                                  evaluation.id_pergunta,
                                  false,
                                  evaluation.jsonPossibilidades
                                )
                        }
                      >
                        {evaluation.valor === 0 ? (
                          <IconDeslikeSelected />
                        ) : isReviewed ? (
                          <IconDeslikeDisabled />
                        ) : (
                          <IconDeslikeUnselected />
                        )}
                        <span>Ruim</span>
                      </div>
                    </div>
                    {evaluation.valor === 0 &&
                      evaluation.jsonSubQ.length !== 0 && (
                        <>
                          <div className="modal-component__general__body-selected1__divider" />
                          <span className="modal-component__general__body-selected1__text">
                            O que não foi legal?
                          </span>
                          <div className="modal-component__general__body-selected1__elements">
                            {evaluation.jsonSubQ.map((element, index) => (
                              <div
                                // className={evaluation.jsonMarked.includes(element.id_resposta) ? "modal-component__general__body-selected1__elements-item__red":"modal-component__general__body-selected1__elements-item__gray"}
                                // onClick={() => handleMarkedNegativedService(element.id_resposta,evaluation.id_avaliacao,evaluation.jsonMarked)}
                                className="modal-component__general__body-selected1__elements-item__red"
                              >
                                <span>{element.desc_subq}</span>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                  </div>
                ))}
              <div className="modal-component__general__body-selected1__comment">
                <span>Deixe um comentário</span>
              </div>
              <div className="modal-component__general__body-selected1__comment-area">
                <textarea
                  className="modal-component__general__body-selected1__comment-area-text"
                  onChange={(event) => setTextObservation(event.target.value)}
                  defaultValue={textObservation}
                  disabled={isReviewed}
                />
              </div>
            </div>
            <div className="modal-component__general__body-actions">
              <Button
                label="Cancelar"
                theme="danger"
                action={() => closeModal()}
              />
              <Button
                label="Salvar"
                disabled={isReviewed ? true : false}
                theme="primary"
                action={() => insertEvaluationNote()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEvaluationModal;
